if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        this.querySelector(".loading-overlay__label").classList.add(
          "invisible"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              this.updateCartCount();
              this.showNotification(response.title);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            this.querySelector(".loading-overlay__label").classList.remove(
              "invisible"
            );
          });
      }

      updateCartCount() {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then((res) => res.json())
          .then((cart) => {
            document.querySelectorAll('a[href="/cart"]').forEach((link) => {
              const spans = link.querySelectorAll("span:not(.sr-only)");
              spans.forEach((span) => {
                if (span.textContent.match(/\(\d+\)/)) {
                  span.innerHTML = span.innerHTML.replace(
                    /\(\d+\)/,
                    `(${cart.item_count})`
                  );
                }
              });
            });
          });
      }

      showNotification(productTitle) {
        const existing = document.getElementById("cart-notification-toast");
        if (existing) existing.remove();

        const notification = document.createElement("div");
        notification.id = "cart-notification-toast";
        notification.className =
          "fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col lg:flex-row lg:items-center gap-3 px-6 py-4 bg-sage text-bone rounded-[10px] shadow-lg transition-all duration-300";
        notification.innerHTML = `
          <svg class="w-5 h-5 fill-bone flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/>
          </svg>
          <span><strong>${productTitle}</strong> added to cart</span>
          <div class="flex items-center gap-8 lg:ml-4">
          <a href="/cart" class="underline font-headline uppercase text-sm">View Cart</a>
          <button class="hover:opacity-70 close-toast">
            <svg class="w-4 h-4 fill-bone" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
            </svg>
          </button>
          </div>
        `;

        document.body.appendChild(notification);

        notification
          .querySelector(".close-toast")
          .addEventListener("click", () => {
            notification.remove();
          });

        setTimeout(() => {
          if (notification.parentElement) {
            notification.style.opacity = "0";
            notification.style.transform = "translateX(100%)";
            setTimeout(() => notification.remove(), 1000);
          }
        }, 5000);
      }

      showCartUpdatedNotice() {
        const container = document.getElementById("buyButton");
        if (!container) return;
        const notice = document.createElement("div");
        notice.className =
          "cart-updated-notice fixed bottom-8 left-1/2 -translate-x-1/2 flex items-center px-8 py-4 text-bone font-headline bg-charred rounded-[10px] z-[999]";
        notice.innerHTML =
          '<svg class="fill-bone mr-2 w-[30px] h-[30px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z"/></svg><span class="text-nowrap">Added to cart</span>';

        container.appendChild(notice);

        requestAnimationFrame(() => {
          notice.classList.add("is-visible");
        });

        setTimeout(() => {
          notice.classList.remove("is-visible");
        }, 900);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}